/**
 * Account — read-only profile + sign-out. Clean & minimal: the console's job is
 * building and downloading; everything else lives in the mobile app.
 */
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/store';
import { Button, Card } from '../components/ui';

export function AccountPage(): JSX.Element {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = (): void => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="page">
      <div className="page-head">
        <h1>Account</h1>
      </div>

      <Card title="Profile">
        <dl className="meta">
          <dt>Email</dt>
          <dd>{user?.email}</dd>
          <dt>Name</dt>
          <dd>{user?.displayName ?? '—'}</dd>
          <dt>Role</dt>
          <dd>{user?.role ?? '—'}</dd>
        </dl>
      </Card>

      <Card title="Session">
        <Button variant="danger" onClick={handleLogout}>
          Sign out
        </Button>
      </Card>
    </div>
  );
}
